import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './pages/misc/reportWebVitals';

// AuthProvider is composed in App.js alongside PollingProvider/Router — do not
// wrap here too, or its session/role-fetch effects run twice.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
